const CURRENT_USER_ROLE_KEY = "current_user_role";

function hasLocalStorage() {
  return typeof window !== "undefined" && typeof window.localStorage !== "undefined";
}

export function getCurrentUserRole(): string {
  if (!hasLocalStorage()) return "";
  try {
    return String(localStorage.getItem(CURRENT_USER_ROLE_KEY) || "").trim();
  } catch (_e) {
    return "";
  }
}

export function setCurrentUserRole(role: string) {
  if (!hasLocalStorage()) return;
  const next = String(role || "").trim();
  if (!next) return;

  try {
    const existing = localStorage.getItem(CURRENT_USER_ROLE_KEY) || "";
    if (existing === next) return;
    localStorage.setItem(CURRENT_USER_ROLE_KEY, next);
  } catch (_e) {
    // ignore storage errors
  }
}

export function clearCurrentUserRole() {
  if (!hasLocalStorage()) return;
  try {
    localStorage.removeItem(CURRENT_USER_ROLE_KEY);
  } catch (_e) {
    // ignore storage errors
  }
}
